import React from "react";
import { Backdrop } from "@material-ui/core";
import Translator from "Languages/Utility/Translator";
import loader from "Assets/LottieLoader/loader.json";
import Lottie from "lottie-react";

function BackDropLoading({ loading, percent, designMode }) {
  return (
    <Backdrop open={loading} className="backDropLoading">
      <div className="loading-container">
        <Lottie animationData={loader} loop={true} style={{ width: "170px" }} />
        <div className="loading-text">
          {designMode ? (
            <>
              <Translator id={"pleaseWaitDesignMode"}/>
              {percent && <span>{` (${percent})`}</span>}
            </>
          ) : (
            <>
              <Translator id={"pleaseWait"} />
              {percent && <span>{` (${percent})`}</span>}
            </>
          )}
        </div>
      </div>
    </Backdrop>
  );
}

export default BackDropLoading;
